<template>
    <div id="parent_newfeed">
        <div class="floating-container lg:block hidden">
            <div class="floating-button">+</div>
            <div class="element-container">
                <span class="float-element cursor-pointer" @click="numberCol = 1">
                    <i class="material-icons">stop</i>
                </span>
                <span class="float-element cursor-pointer" @click="numberCol = 2">
                    <i class="material-icons">grid_view</i>
                </span>
                <span class="float-element cursor-pointer" @click="numberCol = 3">
                    <i class="material-icons">apps</i>
                </span>
            </div>
        </div>
        <div id="newfeed" class="vx-row" :class="{'xl:px-20 mx-0' : (numberCol === 1)}">
            <div v-for="(data, i) in numberCol" :key="i"
                 :class="numberCol === 1 ? 'vx-col lg:w-full' : `vx-col lg:w-1/${numberCol}`">
                <div v-for="(res, indexRes) in newfeedData" :key="indexRes">
                    <div class="vx-row" v-if="((indexRes % numberCol) + 1) === (i + 1)">
                        <div
                            :class="{'vx-col w-full mt-8' :(numberCol > 1), 'vx-col lg:px-20 lg:mx-20 w-full mt-4' : (numberCol === 1)}">
                            <div class="vx-card">
                                <div class="post-header">
                                    <div class="post-author-info">
                                        <img :src="res.avatar" alt="avatar"/>
                                        <div>
                                            <div>
                                                <span class="author-name">{{ res.fullName }}</span>
                                            </div>
                                            <div class="details">
                                                <span>{{ elapsedTime(res.createdDate) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <vs-dropdown class="cursor-pointer" vs-trigger-click>
                                            <a class="a-icon" href.prevent>
                                                <i class="post-menu-icon"></i>
                                            </a>

                                            <vs-dropdown-menu>
                                                <ul style="min-width: 11rem">
                                                    <li
                                                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                                        @click="editNewsFeed(res, indexRes)">
                                                        <feather-icon icon="Edit2Icon" svgClasses="w-4 h-4"/>
                                                        <span class="ml-2">Chi tiết bài viết</span>
                                                    </li>
                                                    <li
                                                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                                        @click="confirmDeleteNewsFeed(res, indexRes)">
                                                        <feather-icon icon="TrashIcon" svgClasses="w-4 h-4"/>
                                                        <span class="ml-2">Xóa bài viết</span>
                                                    </li>
                                                </ul>
                                            </vs-dropdown-menu>
                                        </vs-dropdown>
                                    </div>
                                </div>
                                <p class="px-4 whitespace-pre-line -mt-4" v-if="res.isSeeMore && res.contentShowLess">
                                    {{ res.contentShowLess }} <span class="cursor-pointer text-primary"
                                                                    @click="res.isSeeMore = false"> ... Xem thêm</span>
                                </p>
                                <p class="px-4 whitespace-pre-line -mt-4" v-if="!res.isSeeMore && res.content">
                                    {{ res.content }} <span v-if="res.contentShowLess"
                                                            class="cursor-pointer text-primary"
                                                            @click="res.isSeeMore = true"> ... Ẩn bớt</span>
                                </p>

                                <div class="image-container relative mt-2">
                                    <a>
                                        <div v-if="res.fileManagers && res.fileManagers.length === 1" class="img_1">
                                            <img class="img-newsfeed" :src="res.fileManagers[0].displayUrl"
                                                 alt="Big Image"
                                                 @click="openGallery(res.fileManagers, 0)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px"
                                                 viewBox="0 0 24 24" fill="none"
                                                 v-if="res.fileManagers[0].fileManagerType === 2"
                                                 class="icon_play cursor-pointer"
                                                 @click="openGallery(res.fileManagers, 0)">
                                                <circle cx="12" cy="12" r="10" stroke="#F8F8F8" stroke-width="1.5"/>
                                                <path
                                                    d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
                                                    stroke="#F8F8F8" stroke-width="1.5"/>
                                            </svg>
                                        </div>
                                        <div v-if="res.fileManagers && res.fileManagers.length === 2"
                                             class="grid grid-cols-2 gap-x-1">
                                            <div v-for="(image, indexFile) in res.fileManagers" :key="indexFile"
                                                 class="relative img_2">
                                                <img class="img-newsfeed-small w-full" :src="image.displayUrl"
                                                     :alt="`Small Image ${indexFile}`"
                                                     @click="openGallery(res.fileManagers, indexFile)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px"
                                                     viewBox="0 0 24 24" fill="none" v-if="image.fileManagerType === 2"
                                                     class="icon_play cursor-pointer"
                                                     @click="openGallery(res.fileManagers, indexFile)">
                                                    <circle cx="12" cy="12" r="10" stroke="#F8F8F8" stroke-width="1.5"/>
                                                    <path
                                                        d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
                                                        stroke="#F8F8F8" stroke-width="1.5"/>
                                                </svg>
                                            </div>
                                        </div>
                                        <div v-if="res.fileManagers && res.fileManagers.length > 2"
                                             class="grid grid-cols-2 gap-x-1">
                                            <div class="img_1">
                                                <img class="img-newsfeed-big w-full"
                                                     :src="res.fileManagers[0].displayUrl"
                                                     alt="Big Image" @click="openGallery(res.fileManagers, 0)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px"
                                                     viewBox="0 0 24 24" fill="none"
                                                     v-if="res.fileManagers[0].fileManagerType === 2"
                                                     class="icon_play_2 cursor-pointer"
                                                     @click="openGallery(res.fileManagers, 0)">
                                                    <circle cx="12" cy="12" r="10" stroke="#F8F8F8" stroke-width="1.5"/>
                                                    <path
                                                        d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
                                                        stroke="#F8F8F8" stroke-width="1.5"/>
                                                </svg>
                                            </div>
                                            <div class="grid grid-cols-1 gap-x-1">
                                                <div v-for="(image, indexFileChild) in res.fileManagers.slice(1, 3)"
                                                     :key="indexFileChild"
                                                     class="relative">
                                                    <img class="img-newsfeed-small w-full" :src="image.displayUrl"
                                                         :alt="`Small Image ${indexFileChild}`"
                                                         @click="openGallery(res.fileManagers, indexFileChild + 1)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="50px" height="50px"
                                                         viewBox="0 0 24 24" fill="none"
                                                         v-if="image.fileManagerType === 2"
                                                         class="icon_play cursor-pointer"
                                                         @click="openGallery(res.fileManagers, indexFileChild + 1)">
                                                        <circle cx="12" cy="12" r="10" stroke="#F8F8F8"
                                                                stroke-width="1.5"/>
                                                        <path
                                                            d="M15.4137 10.941C16.1954 11.4026 16.1954 12.5974 15.4137 13.059L10.6935 15.8458C9.93371 16.2944 9 15.7105 9 14.7868L9 9.21316C9 8.28947 9.93371 7.70561 10.6935 8.15419L15.4137 10.941Z"
                                                            stroke="#F8F8F8" stroke-width="1.5"/>
                                                    </svg>
                                                    <div v-if="indexFileChild === 1 && res.fileManagers.length !== 3"
                                                         class="overlay cursor-pointer"
                                                         @click="openGallery(res.fileManagers, indexFileChild + 1)">
                                                        +{{ res.fileManagers.length - 3 }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>


                                <div class="like-and-comment relative">
                                    <div class="post-reactions">
                                        <div class="reactions">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24px"
                                                 height="24px"
                                                 viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z"
                                                    fill="red"/>
                                            </svg>
                                            <span>{{
                                                    res.liked ? 'Bạn và ' + res.interactionCount + ' người khác' : res.interactionCount
                                                }}</span>
                                        </div>
                                        <div class="comment-share">
                                            <div @click="toggleComment(res.id)" class="cursor-pointer"
                                                 v-if="res.commentCount > 0">
                                                <span> {{ res.commentCount }} </span>
                                                <span>Bình luận</span>
                                            </div>
                                            <!--                                            <div class="shares ml-6">-->
                                            <!--                                                <span> 1 </span>-->
                                            <!--                                                <span>Chia sẻ</span>-->
                                            <!--                                            </div>-->
                                        </div>
                                    </div>
                                    <div class="post-actions relative p-0">
                                        <div class="actions cursor-pointer">
                                            <div class="action hover:bg-grey-light" @click="toggleHeart(res, indexRes)">
                                                <svg v-if="!res.liked" xmlns="http://www.w3.org/2000/svg" width="24px"
                                                     height="24px" viewBox="0 0 24 24" fill="none">
                                                    <path
                                                        d="M8.96173 18.9109L9.42605 18.3219L8.96173 18.9109ZM12 5.50063L11.4596 6.02073C11.601 6.16763 11.7961 6.25063 12 6.25063C12.2039 6.25063 12.399 6.16763 12.5404 6.02073L12 5.50063ZM15.0383 18.9109L15.5026 19.4999L15.0383 18.9109ZM9.42605 18.3219C7.91039 17.1271 6.25307 15.9603 4.93829 14.4798C3.64922 13.0282 2.75 11.3345 2.75 9.1371H1.25C1.25 11.8026 2.3605 13.8361 3.81672 15.4758C5.24723 17.0866 7.07077 18.3752 8.49742 19.4999L9.42605 18.3219ZM2.75 9.1371C2.75 6.98623 3.96537 5.18252 5.62436 4.42419C7.23607 3.68748 9.40166 3.88258 11.4596 6.02073L12.5404 4.98053C10.0985 2.44352 7.26409 2.02539 5.00076 3.05996C2.78471 4.07292 1.25 6.42503 1.25 9.1371H2.75ZM8.49742 19.4999C9.00965 19.9037 9.55954 20.3343 10.1168 20.6599C10.6739 20.9854 11.3096 21.25 12 21.25V19.75C11.6904 19.75 11.3261 19.6293 10.8736 19.3648C10.4213 19.1005 9.95208 18.7366 9.42605 18.3219L8.49742 19.4999ZM15.5026 19.4999C16.9292 18.3752 18.7528 17.0866 20.1833 15.4758C21.6395 13.8361 22.75 11.8026 22.75 9.1371H21.25C21.25 11.3345 20.3508 13.0282 19.0617 14.4798C17.7469 15.9603 16.0896 17.1271 14.574 18.3219L15.5026 19.4999ZM22.75 9.1371C22.75 6.42503 21.2153 4.07292 18.9992 3.05996C16.7359 2.02539 13.9015 2.44352 11.4596 4.98053L12.5404 6.02073C14.5983 3.88258 16.7639 3.68748 18.3756 4.42419C20.0346 5.18252 21.25 6.98623 21.25 9.1371H22.75ZM14.574 18.3219C14.0479 18.7366 13.5787 19.1005 13.1264 19.3648C12.6739 19.6293 12.3096 19.75 12 19.75V21.25C12.6904 21.25 13.3261 20.9854 13.8832 20.6599C14.4405 20.3343 14.9903 19.9037 15.5026 19.4999L14.574 18.3219Z"
                                                        fill="#1C274C"/>
                                                </svg>
                                                <svg v-if="res.liked" xmlns="http://www.w3.org/2000/svg" width="24px"
                                                     height="24px" viewBox="0 0 24 24" fill="none">
                                                    <path
                                                        d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z"
                                                        fill="red"/>
                                                </svg>
                                                <span>Yêu thích</span>
                                            </div>
                                            <div class="action hover:bg-grey-light" @click="toggleComment(res.id)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"
                                                     viewBox="0 0 24 24" version="1.1">
                                                    <title>ic_fluent_comment_24_regular</title>
                                                    <desc>Created with Sketch.</desc>
                                                    <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none"
                                                       fill-rule="evenodd">
                                                        <g id="ic_fluent_comment_24_regular" fill="#1b1c1d"
                                                           fill-rule="nonzero">
                                                            <path
                                                                d="M5.25,18 C3.45507456,18 2,16.5449254 2,14.75 L2,6.25 C2,4.45507456 3.45507456,3 5.25,3 L18.75,3 C20.5449254,3 22,4.45507456 22,6.25 L22,14.75 C22,16.5449254 20.5449254,18 18.75,18 L13.0124851,18 L7.99868152,21.7506795 C7.44585139,22.1641649 6.66249789,22.0512036 6.2490125,21.4983735 C6.08735764,21.2822409 6,21.0195912 6,20.7499063 L5.99921427,18 L5.25,18 Z M12.5135149,16.5 L18.75,16.5 C19.7164983,16.5 20.5,15.7164983 20.5,14.75 L20.5,6.25 C20.5,5.28350169 19.7164983,4.5 18.75,4.5 L5.25,4.5 C4.28350169,4.5 3.5,5.28350169 3.5,6.25 L3.5,14.75 C3.5,15.7164983 4.28350169,16.5 5.25,16.5 L7.49878573,16.5 L7.49899997,17.2497857 L7.49985739,20.2505702 L12.5135149,16.5 Z"
                                                                id="🎨-Color">

                                                            </path>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <span>Bình luận</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!--Bình luận bài viết-->
                                    <div id="comment_app" class="comment w-full">
                                        <form v-if="activeComments[res.id]"
                                              class="w-full" v-on:submit.prevent='submit(res.id)'
                                              style="border-bottom: 1px solid #ced0d4; border-top: 1px solid #ced0d4">
                                            <div class="form-group relative">
                                                <div class="relative">
                                                    <input
                                                        required="required"
                                                        placeholder="Viết bình luận..."
                                                        v-model='input'
                                                        class="form-control w-full border-none p-5 custom-input"
                                                    />

                                                    <div class="svg-icons flex">
                                                    <span class=" mr-5">
                                                    </span>
                                                        <span class="cursor-pointer"
                                                              v-on:submit.prevent='submit(res.id)'
                                                              @click="submit(res.id)">

                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                     height="24" viewBox="0 0 24 24" fill="none">
<path
    d="M11.5003 12H5.41872M5.24634 12.7972L4.24158 15.7986C3.69128 17.4424 3.41613 18.2643 3.61359 18.7704C3.78506 19.21 4.15335 19.5432 4.6078 19.6701C5.13111 19.8161 5.92151 19.4604 7.50231 18.7491L17.6367 14.1886C19.1797 13.4942 19.9512 13.1471 20.1896 12.6648C20.3968 12.2458 20.3968 11.7541 20.1896 11.3351C19.9512 10.8529 19.1797 10.5057 17.6367 9.81135L7.48483 5.24303C5.90879 4.53382 5.12078 4.17921 4.59799 4.32468C4.14397 4.45101 3.77572 4.78336 3.60365 5.22209C3.40551 5.72728 3.67772 6.54741 4.22215 8.18767L5.24829 11.2793C5.34179 11.561 5.38855 11.7019 5.407 11.8459C5.42338 11.9738 5.42321 12.1032 5.40651 12.231C5.38768 12.375 5.34057 12.5157 5.24634 12.7972Z"
    stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                        <div class="w-full p-5" v-if="activeComments[res.id]">
                                            <div class="">
                                                <div class="list-group">
                                                    <div class="list-group-item"
                                                         v-for="(comment,indexCmt) in res.dataReply"
                                                         :key="indexCmt">
                                                        <div class="comment-container w-full block">
                                                            <div class="comment-content pb-5">
                                                                <div class="flex">
                                                                    <img class="avatar-circle mt-3"
                                                                         :src="comment.avatar"
                                                                         alt="Av">
                                                                    <div class="ml-2">
                                                                        <p class="list-group-item-reply">
                                                                            <strong>{{ comment.fullName }} </strong>
                                                                            <br>
                                                                            {{ comment.content }} <br>
                                                                        </p>
                                                                        <div class="ml-4">
                                                                            <strong
                                                                                class="text-sm cursor-pointer hover:text-primary"
                                                                                @click="replyComment(indexRes, indexCmt, comment)">Phản
                                                                                hồi</strong>
                                                                            <strong
                                                                                class="text-sm ml-5">{{
                                                                                    elapsedTime(comment.createdDate)
                                                                                }}</strong>
                                                                        </div>
                                                                    </div>
                                                                    <div class="button-delete-comment mt-6 ml-3"
                                                                         v-if="userInfo.fullName === comment.fullName.trim()">
                                                                        <vs-dropdown class="absolute cursor-pointer"
                                                                                     vs-trigger-click>
                                                                            <a class="a-icon flex justify-center mb-4 items-center"
                                                                               href.prevent>
                                                                                <i class="post-menu-icon"></i>
                                                                            </a>
                                                                            <vs-dropdown-menu>
                                                                                <ul>
                                                                                    <li
                                                                                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                                                                        @click="deleteComment(res, res, indexCmt)">
                                                                                        <feather-icon icon="TrashIcon"
                                                                                                      svgClasses="w-4 h-4"/>
                                                                                        <span
                                                                                            class="ml-2">Xóa bình luận</span>
                                                                                    </li>
                                                                                </ul>
                                                                            </vs-dropdown-menu>
                                                                        </vs-dropdown>
                                                                    </div>
                                                                </div>
                                                                <div class="ml-16">
                                                                    <div class="list-group">
                                                                        <div class="mt-4"
                                                                             v-for='(reply,indexChild) in comment.childList'
                                                                             :key="indexChild">
                                                                            <div class="flex">
                                                                                <div class="mr-3">
                                                                                    <img class="avatar-circle mt-3"
                                                                                         :src="reply.avatar"
                                                                                         alt="Av">
                                                                                </div>
                                                                                <p class="list-group-item-reply">
                                                                                    <strong>{{
                                                                                            reply.fullName
                                                                                        }}</strong>
                                                                                    <br>
                                                                                    <b class="text-primary">{{
                                                                                            reply.responseFullName ? reply.responseFullName : null
                                                                                        }}</b> {{ reply.content }}
                                                                                </p>
                                                                                <div
                                                                                    class="button-delete-comment mt-6 ml-3"
                                                                                    v-if="userInfo.fullName === reply.fullName.trim()">
                                                                                    <vs-dropdown
                                                                                        class="absolute cursor-pointer"
                                                                                        vs-trigger-click>
                                                                                        <a class="a-icon flex justify-center mb-4 items-center"
                                                                                           href.prevent>
                                                                                            <i class="post-menu-icon"></i>
                                                                                        </a>
                                                                                        <vs-dropdown-menu>
                                                                                            <ul>
                                                                                                <li
                                                                                                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                                                                                    @click="deleteComment(res, comment, indexChild)">
                                                                                                    <feather-icon
                                                                                                        icon="TrashIcon"
                                                                                                        svgClasses="w-4 h-4"/>
                                                                                                    <span
                                                                                                        class="ml-2">Xóa bình luận</span>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </vs-dropdown-menu>
                                                                                    </vs-dropdown>
                                                                                </div>
                                                                            </div>
                                                                            <div class="ml-16 -mt-2">
                                                                                <strong
                                                                                    class="text-sm cursor-pointer hover:text-primary"
                                                                                    @click="replyComment(indexRes, indexCmt, comment, reply)">Phản
                                                                                    hồi</strong>
                                                                                <strong class="text-sm ml-5">{{
                                                                                        elapsedTime(reply.createdDate)
                                                                                    }}</strong>
                                                                            </div>
                                                                        </div>
                                                                        <div class="mt-2" v-if="comment.isReply">
                                                                            <form class="block"
                                                                                  v-on:submit.prevent='addReply(comment.id, res.id, reply)'>
                                                                                <img class="avatar-circle mr-3"
                                                                                     :src="userInfo.img"
                                                                                     alt="Av">
                                                                                <b class="text-primary mr-2">{{
                                                                                        '@' + tagName[comment.id]
                                                                                    }}</b>
                                                                                <input v-model='reply[comment.id]'
                                                                                       required="required"
                                                                                       placeholder="Viết phản hồi..."
                                                                                       class="border-none"
                                                                                />
                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="24"
                                                                                    @click="addReply(comment.id, res.id, reply)"
                                                                                    height="24" viewBox="0 0 24 24"
                                                                                    fill="none"
                                                                                    class="cursor-pointer float-right">
                                                                                    <path
                                                                                        d="M11.5003 12H5.41872M5.24634 12.7972L4.24158 15.7986C3.69128 17.4424 3.41613 18.2643 3.61359 18.7704C3.78506 19.21 4.15335 19.5432 4.6078 19.6701C5.13111 19.8161 5.92151 19.4604 7.50231 18.7491L17.6367 14.1886C19.1797 13.4942 19.9512 13.1471 20.1896 12.6648C20.3968 12.2458 20.3968 11.7541 20.1896 11.3351C19.9512 10.8529 19.1797 10.5057 17.6367 9.81135L7.48483 5.24303C5.90879 4.53382 5.12078 4.17921 4.59799 4.32468C4.14397 4.45101 3.77572 4.78336 3.60365 5.22209C3.40551 5.72728 3.67772 6.54741 4.22215 8.18767L5.24829 11.2793C5.34179 11.561 5.38855 11.7019 5.407 11.8459C5.42338 11.9738 5.42321 12.1032 5.40651 12.231C5.38768 12.375 5.34057 12.5157 5.24634 12.7972Z"
                                                                                        stroke="#000000"
                                                                                        stroke-width="2"
                                                                                        stroke-linecap="round"
                                                                                        stroke-linejoin="round"/>
                                                                                </svg>
                                                                            </form>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isPreview">
                <div class="preview-media">
                    <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor"
                         stroke-width="2" fill="none"
                         stroke-linecap="round" stroke-linejoin="round"
                         class="css-i6dzq1 cursor-pointer" @click="preVideo"
                         v-if="isShowMedia && media.length > 1">
                        <line x1="19" y1="12" x2="5" y2="12"></line>
                        <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                    <img v-if="isShowMedia && mediaPreview.fileManagerType === 1"
                         :src="mediaPreview.url"
                         alt="">
                    <video id="video-play" controls autoplay
                           v-if="isShowMedia && mediaPreview.fileManagerType === 2">
                        <source :src="mediaPreview.url" type="video/mp4">
                    </video>
                    <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor"
                         stroke-width="2" fill="none"
                         stroke-linecap="round" stroke-linejoin="round"
                         class="css-i6dzq1 cursor-pointer" @click="nextVideo"
                         v-if="isShowMedia && media.length > 1">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </div>
                <div class="button-close-preview flex justify-end">
                    <svg viewBox="0 0 24 24" width="26" height="26" stroke="currentColor"
                         stroke-width="2" fill="none"
                         stroke-linecap="round" stroke-linejoin="round"
                         class="css-i6dzq1 cursor-pointer"
                         @click="closePreview">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import "../../../../assets/css/newfedd.css";
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';

export default {
    name: "NewFeed",
    components: {
        VueUploadMultipleImage,
    },
    data() {
        return {
            newfeedData: [],
            isHeart: false,
            input: "",
            total_comments: 0,
            comments: [],
            images: [],
            popupActivo4: false,
            currentIndex: 0,
            parentId: null,
            isShow: false,
            activeComments: {},
            reply: [],
            tagName: [],
            showUploadImg: false,
            selectedDeleteData: null,
            isPreview: false,
            isShowMedia: false,
            mediaPreview: null,
            indMedia: null,
            media: [],
            pageNumber: 0,
            pageSize: 6,
            userInfo: null,
            numberCol: 1,
        }
    },
    created() {

        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (this.userInfo.img && this.userInfo.img.includes('infocare')) this.userInfo.img = this.userInfo.img.replace('cdn.infocare', 'cdnImage.inviv');
        this.getAllNews(true);
    },

    watch: {
        '$store.state.scrollY'() {
            if ((window.innerHeight + window.scrollY) >= (document.getElementById('parent_newfeed').offsetHeight + 105)) {
                this.pageNumber = this.pageNumber + 1;
                this.getAllNews(true);
            }
        },
    },

    methods: {
        getAllNews(check) {
            if (!check) {
                this.newfeedData = [];
                this.pageNumber = 0;
            }

            let payload = {
                keySearch: '',
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                status: 2,
            };

            this.$vs.loading();

            this.$crm.post('/beauty-news-feed/find-by-condition', payload).then(res => {
                res.data.content.forEach(x => {
                    x.dataReply = [];
                });
                let data = res.data.content.map(el => {
                    if (el.avatar && el.avatar.includes('infocare')) el.avatar = el.avatar.replace('cdn.infocare', 'cdnImage.inviv');
                    el.isSeeMore = false;
                    if (el.content) {
                        let str = el.content.split(' ');
                        if (str.length > 100) {
                            str = str.filter(el => str.indexOf(el) < 100);
                            el.contentShowLess = str.join(' ');
                            el.isSeeMore = true;
                        }
                    }
                    return el;
                });
                this.newfeedData.push(...data);
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        confirmDeleteNewsFeed(res) {
            this.selectedDeleteData = res;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: 'Bạn có chắc là muốn xóa bài viết này không?',
                accept: this.deleteNewsFeed,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteNewsFeed() {
            this.$crm.get(`/beauty-news-feed/delete/${this.selectedDeleteData.id}`).then(() => {
                this.$vs.notify({
                    text: 'Xóa bài viết thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.getAllNews(false);
                this.$vs.loading.close();
            }).catch(() => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        editNewsFeed(data) {
            this.$router.push(`/user/posts-info?id=${data.id}`).catch(() => {
            })
        },
        toggleHeart(res) {
            res.liked = !res.liked;
            const payload = [
                {
                    newsFeedId: res.id,
                    status: res.liked ? 1 : 0
                },

            ]
            this.$crm.post('/beauty-interaction-history/interact', payload).then(() => {
                this.getAllNews(res.id);
            }).catch(err => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        submit(newsFeedId) {
            if (this.input.trim().length === 0) {
                return this.$vs.notify({
                    text: 'Không được để trống trường bình luân!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            let payload = {
                beautyNewsFeedId: newsFeedId,
                content: this.input,
            }
            this.$vs.loading();
            this.$crm.post(`/beauty-comment-history/create`, payload).then(response => {
                this.$vs.loading.close();
                this.total_comments++;
                this.input = "";
                // Thêm dữ liệu mới vào dataReply
                this.newfeedData.forEach(newsfeed => {
                    if (newsfeed.id === newsFeedId) {
                        newsfeed.dataReply.push({
                            id: response.data.id,
                            fullName: response.data.fullName ? response.data.fullName : '',
                            // content: formData.get('content')
                        });
                    }
                });
                this.getAllComments(newsFeedId);

            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.images = []
        },

        addReply(commentId, newsFeedId, replyContent) {
            if (!replyContent[commentId] || replyContent[commentId].trim().length === 0) {
                return this.$vs.notify({
                    text: 'Phản hồi phải có nội dung!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            let payload = {
                beautyNewsFeedId: newsFeedId,
                content: replyContent[commentId],
                parentId: this.parentId,
            }
            this.$vs.loading();
            this.$crm.post(`/beauty-comment-history/create`, payload).then(response => {
                // Thêm dữ liệu mới vào dataReply
                this.newfeedData.forEach(newsfeed => {
                    if (newsfeed.id === newsFeedId) {
                        newsfeed.dataReply.push({
                            id: response.data.id,
                            fullName: response.data.fullName ? response.data.fullName : '',
                            // content: formData.get('content')
                        });
                    }
                });
                replyContent[commentId] = '';
                this.getAllComments(newsFeedId);
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        //Images
        async uploadImageSuccess(formData, index, fileList,) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.setIsUpdateImages();
            done();
            this.images = fileList;
        },

        dataChange() {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        getAllComments(id) {
            return new Promise((resolve, reject) => {
                let payload = {
                    beautyNewsFeedId: id,
                    // pageNumber: this.pageNumber,
                    // pageSize: this.pageSize,
                };
                this.$vs.loading();
                const newsfeed = this.newfeedData.find(feed => feed.id === id);
                this.$crm.post('/beauty-comment-history/find-by-condition', payload).then(res => {
                    if (newsfeed) {
                        newsfeed.commentCount = res.data.totalElements;
                        newsfeed.dataReply = res.data.content.sort((a, b) => b.id - a.id).map(el => {
                            el.childList.reverse().forEach(x => {
                                if (x.avatar.includes('infocare')) x.avatar = x.avatar.replace('cdn.infocare', 'cdnImage.inviv');
                            });
                            if (el.avatar && el.avatar.includes('infocare')) el.avatar = el.avatar.replace('cdn.infocare', 'cdnImage.inviv');
                            el.isReply = false;
                            return el;
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async deleteComment(res, comment, index) {
            let deleteId = (comment.childList && comment.childList.length > 0) ? comment.childList[index].id : res.dataReply[index].id;
            await this.$crm.get(`/beauty-comment-history/delete/${deleteId}`).then(() => {
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
            await this.getAllComments(res.id)
        },

        async toggleComment(id) {
            if (!this.activeComments[id]) await this.getAllComments(id);
            this.$set(this.activeComments, id, !this.activeComments[id]);
        },
        elapsedTime(startTime) {
            let x = new Date(startTime)
            let now = new Date()
            let timeDiff = now - x;
            timeDiff /= 1000

            let seconds = Math.round(timeDiff)
            timeDiff = Math.floor(timeDiff / 60)

            let minutes = Math.round(timeDiff % 60)
            timeDiff = Math.floor(timeDiff / 60)

            let hours = Math.round(timeDiff % 24)
            timeDiff = Math.floor(timeDiff / 24)

            let days = Math.round(timeDiff % 365)
            timeDiff = Math.floor(timeDiff / 365)

            let years = timeDiff

            if (years > 0) {
                return years + (years > 1 ? this.$t('notification.years') : this.$t('notification.year')) + this.$t('notification.ago')
            } else if (days > 0) {
                return days + (days > 1 ? this.$t('notification.days') : this.$t('notification.day')) + this.$t('notification.ago')
            } else if (hours > 0) {
                return hours + (hours > 1 ? this.$t('notification.hrs') : this.$t('notification.hour')) + this.$t('notification.ago')
            } else if (minutes > 0) {
                return minutes + (minutes > 1 ? this.$t('notification.mins') : this.$t('notification.min')) + this.$t('notification.ago')
            } else if (seconds > 0) {
                return (seconds > 1 ? seconds + this.$t('notification.secAgo') : this.$t('notification.justNow'))
            }

            return this.$t('notification.justNow')
        },

        openGallery(viv, index) {
            this.indMedia = index
            this.media = viv;
            this.mediaPreview = this.media[index]
            this.isPreview = true;
            this.isShowMedia = true;
        },

        closePreview() {
            this.isPreview = false;
            this.isShowMedia = false;
            this.media = [];
        },

        nextVideo() {
            this.isShowMedia = false;
            let checkLength = this.media.length
            this.indMedia = this.indMedia + 1;
            if (this.indMedia + 1 > checkLength) this.indMedia = 0;
            this.mediaPreview = this.media[this.indMedia];
            setTimeout(() => {
                this.isShowMedia = true;
            }, 1)
        },

        preVideo() {
            this.isShowMedia = false;
            if (this.indMedia === 0) {
                this.indMedia = this.media.length - 1;
            } else {
                this.indMedia = this.indMedia - 1;
            }
            this.mediaPreview = this.media[this.indMedia];
            setTimeout(() => {
                this.isShowMedia = true;
            }, 1)
        },

        checkUser(username) {
            if (username === this.userInfo.username) return true;
            return false
        },

        replyComment(indexRes, indexCmt, comment, reply) {
            this.newfeedData[indexRes].dataReply[indexCmt].isReply = false;
            this.reply[comment.id] = null;
            this.tagName[comment.id] = null;
            this.parentId = reply ? reply.id : comment.id;
            this.tagName[comment.id] = reply ? reply.fullName : comment.fullName;
            this.newfeedData[indexRes].dataReply[indexCmt].isReply = true;
        },
    },
}
</script>

<style lang="scss">

#parent_newfeed {
    .img-newsfeed,
    .img-newsfeed-big,
    .img-newsfeed-small {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        object-position: center;
    }

    .floating-button {
        position: relative;
        bottom: 20px;
        right: 20px;
        z-index: 1000;
    }

    @media (min-width: 1536px) {
        .img_1 {
            height: 506px;

            img {
                height: 506px;
            }
        }

        .img_2 {
            height: 500px;

            img {
                height: 500px;
            }
        }
        .img-newsfeed {
            height: 500px;
        }
        .img-newsfeed-small,
        .overlay {
            height: 250px;
        }
    }

    @media (min-width: 640px) and (max-width: 1535px) {
        .img-newsfeed {
            height: 300px;
        }
        .img-newsfeed-small,
        .overlay {
            height: 150px;
        }
        .img_1 {
            height: 306px;

            img {
                height: 306px;
            }
        }

        .img_2 {
            height: 300px;

            img {
                height: 300px;
            }
        }
    }

    @media (max-width: 639px) {
        .img-newsfeed {
            height: 200px;
        }
        .img-newsfeed-small,
        .overlay {
            height: 100px;
        }

        .img_1 {
            height: 206px;

            img {
                height: 206px;
            }
        }

        .img_2 {
            height: 200px;

            img {
                height: 200px;
            }
        }
        .overlay {
            height: 100px;
        }
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: #fff;
    }

    .svg-icons {
        position: absolute;
        display: flex;
        align-items: center;
        top: 50%;
        right: 50px;
        transform: translateY(-50%);
    }

    .avatar-circle {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
    }

    .avatar-circle img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .comment-container {
        display: flex;
        align-items: flex-start;
    }

    .comment-content {
        margin-left: 10px;
    }

    .list-group-item-reply {
        //width: 100%;
        //min-width: 300px;
        border-radius: 20px;
        background-color: #F0F2F5;
        padding: 10px;
        margin-bottom: 10px;
    }

    ::v-deep .vs-popup .vs-popup--content {
        overflow: hidden;
    }

    .arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        cursor: pointer;
    }

    @media (min-width: 1200px) {
        .preview-media,
        .button-close-preview {
            margin-left: 260px !important;
            width: calc(100% - 260px) !important;
        }
    }

    @media (max-width: 1199px) {
        .preview-media,
        .button-close-preview {
            margin-left: 0 !important;
            width: 100% !important;
        }
    }

    .preview-media {
        left: 0;
        background-color: rgba(0, 0, 0, .9);
        padding: 10px 20px 10px 10px;
        -webkit-transition: opacity .3s ease;
        color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: fixed;
        z-index: 1000;
        top: 0;
        width: 100%;
        height: 100%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        //box-align: center;
        //box-pack: center;
        transition: opacity .3s ease;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;

        video, img {
            max-height: calc(100vh);
            cursor: pointer;
            display: block;
            height: 100%;
            margin: 0 auto;
            max-width: 90%;
            -webkit-user-select: none;
            padding-top: 62px !important;
        }
    }

    .button-close-preview {
        left: 0;
        padding: 10px 20px 10px 10px;
        -webkit-transition: opacity .3s ease;
        color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: fixed;
        z-index: 9999;
        top: 62px;
        width: 100%;
        height: 62px;
        transition: opacity .3s ease;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    @media (min-width: 641px) {
        .icon_play {
            position: absolute;
            left: 45%;
            top: 40%;
        }
    }

    @media (max-width: 640px) {
        .icon_play {
            position: absolute;
            left: 45%;
            top: 25%;
        }
    }

    .icon_play_2 {
        position: absolute;
        left: 22%;
        top: 40%;
    }

    .vs-sidebar--background {
        top: 62px;
        left: 260px;
    }

    .vs-sidebar.vs-sidebar-primary.vs-sidebar-position-right {
        top: 62px;
    }

    //.btn_menu_newfeed {
    //    position: relative;
    //    float: right;
    //    cursor: pointer;
    //    background-color: #dedede;
    //    width: 40px;
    //    height: 40px;
    //    border-radius: 50%;
    //    padding: 10px;
    //}
}
</style>

<style lang="scss">
@-webkit-keyframes come-in {
    0% {
        -webkit-transform: translatey(100px);
        transform: translatey(100px);
        opacity: 0;
    }
    30% {
        -webkit-transform: translateX(-50px) scale(0.4);
        transform: translateX(-50px) scale(0.4);
    }
    70% {
        -webkit-transform: translateX(0px) scale(1.2);
        transform: translateX(0px) scale(1.2);
    }
    100% {
        -webkit-transform: translatey(0px) scale(1);
        transform: translatey(0px) scale(1);
        opacity: 1;
    }
}

@keyframes come-in {
    0% {
        -webkit-transform: translatey(100px);
        transform: translatey(100px);
        opacity: 0;
    }
    30% {
        -webkit-transform: translateX(-50px) scale(0.4);
        transform: translateX(-50px) scale(0.4);
    }
    70% {
        -webkit-transform: translateX(0px) scale(1.2);
        transform: translateX(0px) scale(1.2);
    }
    100% {
        -webkit-transform: translatey(0px) scale(1);
        transform: translatey(0px) scale(1);
        opacity: 1;
    }
}

.floating-container {
    position: relative;
    float: right;
    width: 50px;
    height: 50px;
    bottom: 0;
    right: 0;
    margin: 10px 0 0 0;
    cursor: pointer;

    .element-container {
        display: none;
    }
}

.floating-container:hover {
    height: 300px;

    .element-container {
        display: block;
    }
}

.floating-container:hover .floating-button {
    /*box-shadow: 0 10px 25px rgba(44, 179, 240, 0.6);*/
    -webkit-transform: translatey(5px);
    transform: translatey(5px);
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.floating-container:hover .element-container .float-element:nth-child(1) {
    -webkit-animation: come-in 0.4s forwards 0.2s;
    animation: come-in 0.4s forwards 0.2s;
    z-index: 9999;
}

.floating-container:hover .element-container .float-element:nth-child(2) {
    -webkit-animation: come-in 0.4s forwards 0.4s;
    animation: come-in 0.4s forwards 0.4s;
    z-index: 9999;
}

.floating-container:hover .element-container .float-element:nth-child(3) {
    -webkit-animation: come-in 0.4s forwards 0.6s;
    animation: come-in 0.4s forwards 0.6s;
    z-index: 9999;
}

.floating-container .floating-button {
    position: absolute;
    width: 40px;
    height: 40px;
    background: rgba(var(--vs-primary), 1);
    bottom: 0;
    border-radius: 50%;
    left: 0;
    right: 0;
    margin: auto;
    color: white;
    line-height: 40px;
    text-align: center;
    font-size: 23px;
    z-index: 100;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.floating-container .float-element {
    position: relative;
    display: block;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin: 15px auto;
    color: white;
    font-weight: 500;
    text-align: center;
    line-height: 50px;
    z-index: 0;
    opacity: 0;
    -webkit-transform: translateY(100px);
    transform: translateY(100px);
}

.floating-container .float-element .material-icons {
    vertical-align: middle;
    font-size: 30px;
}

.floating-container .float-element:nth-child(1) {
    background: #42A5F5;
}

.floating-container .float-element:nth-child(2) {
    background: #4CAF50;
}

.floating-container .float-element:nth-child(3) {
    background: #FF9800;
}
</style>
